export default function wrapLead() {
    let productLead = document.querySelector(".product-main .product-lead");

    if (!productLead) return;

    let productLeadWrapper = productLead.querySelector(".product-lead--content-wrapper");
    let productLeadContent = productLead.querySelector(".product-lead--content");

    if (
        productLeadWrapper.getBoundingClientRect().height <
        productLeadContent.getBoundingClientRect().height
    ) {
        productLead.classList.add("overflow");
        let opener = productLead.querySelector(".product-lead--opener");

        opener.addEventListener("click", function() {
            if (productLead.classList.contains('open')) {
                productLead.classList.remove("open");
                productLead.scrollIntoViewIfNeeded();
            } else {
                productLead.classList.add("open");
            }
        });
    } else {
        productLead.classList.remove("overflow");
        productLead.classList.add("open");
    }
}
